import Vue from 'vue'
import Cookies from 'js-cookie'
import dayjs from 'dayjs'
import customParseFormat from "dayjs/plugin/customParseFormat"
import {
    throttle,
    objMatch,
    deepTraverse,
    setUnion,
    listToTree,
    type,
    pathJoin,
    currency,
    qs,
} from 'es-sharp'
import defaultAvatar from '@/assets/images/defaultAvatar.jpg'
// dayjs 扩展
dayjs.extend(customParseFormat)

export {
    throttle,
    objMatch,
    deepTraverse,
    setUnion,
    listToTree,
    type,
    pathJoin,
    qs,
}

export function tokenKey() {
    return Vue.$config.pageName
}

export function setToken(key, token) {
    if (arguments.length == 1) {
        token = key
        key = tokenKey()
    }

    Cookies.set(key, token, { expires: Vue.$config.cookieExpires || 1 })
}

export function getToken(key, beJson) {
    var token

    if (beJson) {
        token = Cookies.getJSON(key || tokenKey())
    } else {
        token = Cookies.get(key || tokenKey())
    }

    if (token) return token
    else return false
}

export const getTarget = () => {
    return Vue.$config.target
}

// 转大写
export function toUpperCase(s) {
    if (!s) return ''

    return s.toString().toUpperCase()
}

// 转小写
export function toLowerCase(s) {
    if (!s) return ''

    return s.toString().toLowerCase()
}

// 时间戳或者时间字符转Date
export function toDate(val, format = 'YYYY-MM-DD HH:mm:ss'){
    if(!val){
        throw new Error("Invalid Date")
    }

    var d,
        t = type(val)

    // 时间戳
    if(t == "number"){
        d = dayjs(val)
    }

    if(t == "string"){
        d = dayjs(val, format)
    }

    if(t == "date"){
        return val
    }

    if (d.toString() == "Invalid Date") {
        throw new Error("Invalid Date")
    }

    return d.toDate()
}

// 日期格式化为 年-月-日 时:分:秒
export function ymdL(s) {
    if (!s) {
        return ''
    }

    var d = dayjs(s)

    if (d.toString() == "Invalid Date") {
        throw new Error("Invalid Date")
    }

    return d.format("YYYY-MM-DD HH:mm:ss")
}

// 日期格式化为 年-月-日
export function ymd(s) {
    if (!s) {
        return ''
    }

    var d = dayjs(s)

    if (d.toString() == "Invalid Date") {
        throw new Error("Invalid Date")
    }

    return d.format("YYYY-MM-DD")
}

// 日期格式化为 年-月
export function ym(s) {
    if (!s) {
        return ''
    }

    var d = dayjs(s)

    if (d.toString() == "Invalid Date") {
        throw new Error("Invalid Date")
    }

    return d.format("YYYY-MM")
}

// 解析动态路由
export function parseDynamicUrl(url, params) {
    return url.replace(/:([^\/]+)/g, (part, name) => {
        return params[name]
    })
}

// 获取路由绝对路径
export function getAbsPath(...paths) {
    return `${window.location.origin}${pathJoin(process.env.VUE_APP_PUBLICK_PATH, ...paths)}`
}

// 获取可发布的绝对路由path
export function getAbsRoutePath(...paths) {
    var { pageName, routerMode } = Vue.$config
    // var abs = pathJoin(`${window.location.origin}${process.env.VUE_APP_PUBLICK_PATH}`, pageName)
    var abs = pathJoin(process.env.VUE_APP_PUBLICK_PATH, pageName)

    // hash模式
    if (routerMode == "hash") {
        return window.location.origin + abs + '#' + pathJoin('/', ...paths)
    }

    return window.location.origin + pathJoin(abs, ...paths)
}

// 获取静态资源绝对路径
export function getAbsStaticPath(...paths) {
    if (process.env.VUE_APP_STATIC_SERVER) {
        var [protocol, host] = process.env.VUE_APP_STATIC_SERVER.split("//")

        return `${protocol}//${pathJoin(host, ...paths)}`
    }

    return getAbsPath(...paths)
}

// 获取微信授权地址
export function getAuthWxUrl({
    scope = "snsapi_userinfo",
    state = "STATE"
} = {}) {
    // snsapi_base snsapi_userinfo
    var { appid } = Vue.$config.wx

    var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + encodeURIComponent(appid) +
        '&redirect_uri=' + encodeURIComponent(getAbsRoutePath('authwx')) +
        '&response_type=code&scope=' + encodeURIComponent(scope) +
        '&state=' + encodeURIComponent(state) +
        '#wechat_redirect'

    console.log(url)

    return url
}

// 是否存在
function hasOneOf(targetarr, arr) {
    return targetarr.some(_ => arr.indexOf(_) > -1)
}

// 菜单权限校验
function showThisMenuEle(item, access) {
    // 目录、Main不做校验
    if (item.meta && (item.meta.isDirectory || item.meta.resType < 0)) {
        return true
    }

    if (item.meta && item.meta.access && item.meta.access.length) {
        return hasOneOf(item.meta.access, access)
    } else {
        return true
    }
}

// 查询主页
export const getHomeRoute = (routers, homeName = 'home') => {
    let i = -1
    let len = routers.length
    let homeRoute = {}
    while (++i < len) {
        let item = routers[i]
        if (item.children && item.children.length) {
            let res = getHomeRoute(item.children, homeName)
            if (res.name) return res
        } else {
            if (item.name === homeName) homeRoute = item
        }
    }
    return homeRoute
}

// 通过路由列表得到菜单列表
export const getMenuByRouter = (list, access) => {
    let res = []

    list.forEach(item => {
        if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
            let obj = {
                icon: (item.meta && item.meta.icon) || '',
                name: (item.meta && item.meta.targetName) || item.name,
                meta: item.meta || {}
            }
            // 子级菜单
            if ((item.children && item.children.length !== 0 || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
                obj.children = getMenuByRouter(item.children, access)
            }
            // 支持静态超链接
            if (item.meta && item.meta.href) obj.href = item.meta.href
            // 权限过滤
            if (showThisMenuEle(item, access)) res.push(obj)
        }
    })

    return res
}

// route转tagNavItem
export const getTagFromRoute = route => {
    let router = {
            name: route.name,
            title: "",
            path: route.path,
            query: route.query,
            params: route.params,
        },
        meta = {}

    if (route.meta) {
        meta.title = route.meta.title
    }

    if (meta.title && typeof meta.title === 'function') {
        meta.title = meta.title(router)
    }

    router.meta = meta

    return router
}

// 判断2个tag标签是否相等
export const tagEqual = (tag1, tag2) => {
    const params1 = tag1.params || {}
    const params2 = tag2.params || {}
    const query1 = Object.assign({}, tag1.query, { "_VTK_": "" })
    const query2 = Object.assign({}, tag2.query, { "_VTK_": "" })

    return (tag1.name === tag2.name) && objMatch(params1, params2) && objMatch(query1, query2)
}

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
export const getNewTagList = (list, newRoute) => {
    let newList = [...list]

    // 已存在
    if (newList.findIndex(v => tagEqual(v, newRoute)) >= 0) {
        return newList
    }

    newList.push(getTagFromRoute(newRoute))

    return newList
}

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
export const getNextTag = (list, route) => {
    let res = {}
    if (list.length === 2) {
        res = getHomeRoute(list)
    } else {
        const index = list.findIndex(item => tagEqual(item, route))

        if (index === list.length - 1) res = list[list.length - 2]
        else res = list[index + 1]
    }

    return getTagFromRoute(res)
}

// 根据路由name翻译菜单名称
export const showTitle = (item, vm) => {
    return vm.$config.useI18n ?
        vm.$t("menu." + item.name) : ((item.meta && item.meta.title) || item.name)
}

// 下载blob流文件
export function downLoadBlob(blob, fileName = "download") {
    if ('download' in document.createElement('a')) { // 非IE下载
        let URL = window.URL || window.webkitURL
        let objectUrl = URL.createObjectURL(blob)
        let elink = document.createElement('a')

        if (typeof elink.download === 'undefined') {
            window.location = objectUrl
        } else {
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = objectUrl
            elink.target = "_blank"
            document.body.appendChild(elink)
            elink.click()

            setTimeout(() => {
                URL.revokeObjectURL(elink.href) // 释放URL 对象
                document.body.removeChild(elink)
            }, 1000)
        }
    } else if (window.navigator.msSaveBlob) { // IE10+下载
        window.navigator.msSaveBlob(blob, fileName)
    } else {
        throw new Error("浏览器不支持Blob下载")
    }
}

// 获取文件预览url
export function getFilePreviewUrl(id = '') {
    return `${Vue.$config.baseURL}api/sys/oss/preview${id ? ('?id=' + id) : '' }`
}

// 获取文件下载url
export function getFileDownloadUrl(id = '') {
    return `${Vue.$config.baseURL}api/sys/oss/download${id ? ('?id=' + id) : '' }`
}

// 时差转换为对用户友好的形式(dis是秒)
export const timeDifToFriendlyDesc = function(sec, options = {}) {
    var { accurate = false, fallback = "" } = options
    var result = '',
        stock = sec,
        month,
        week,
        day,
        hour,
        minute,
        second

    if (stock > 18144000) {
        month = Math.floor(stock / 18144000)
        stock = stock - 18144000 * month
        result += month + "个月"

        if (accurate == false) {
            return month + "个月"
        }
    }

    if (stock > 604800) {
        week = Math.floor(stock / 604800)
        stock = stock - 604800 * week
        result += week + "周"

        if (accurate == false) {
            return week + "周"
        }
    }

    if (stock > 86400) {
        day = Math.floor(stock / 86400)
        stock = stock - 86400 * day
        result += day + "天"

        if (accurate == false) {
            return day + "天"
        }
    }

    if (stock > 3600) {
        hour = Math.floor(stock / 3600)
        stock = stock - 3600 * hour
        result += hour + "时"

        if (accurate == false) {
            return hour + "时"
        }
    }

    if (stock > 60) {
        minute = Math.floor(stock / 60)
        stock = stock - 60 * minute
        result += minute + "分"

        if (accurate == false) {
            return minute + "分"
        }
    }

    if (sec > 0) {
        second = stock
        result += Math.floor(stock) + "秒"

        if (accurate == false) {
            return second + "秒"
        }
    }

    return result ? result : fallback
}

// 获取oss图片url
export function getPublicImgUrls(s) {
    if (!s || s == "0") {
        return []
    }

    var files

    switch (type(s)) {
        case "object": 
            files = [s]
            break;
        case "array":
            files = s
            break;
        case "string":
            files = JSON.safeParse(s) || s.split(',').map(id => ({ id }))
            break;
        default:
            files = []
    }

    return files.map(v => v.path ? getAbsStaticPath(v.path) : getFilePreviewUrl(v.id))
}

// 从附件中获取首图
export function getCoverImg(attachments) {
    var urls = getPublicImgUrls(attachments)

    return urls.length ? urls[0] : ""
}

// 获取用户头像
export function getUserAvatar(attachments) {
    return getCoverImg(attachments) || defaultAvatar
}